import { toast } from 'react-toastify'
import { resetCompany_action, resetContent_action, reseTeams_action, resetSubsription_action, resetTemplates_action } from 'store/actions'
import { history, store } from 'store/store'
import { getLocalStorageValue, unsetLocalStorageValue } from './storageUtils'

export default async function apiService(path, params, method, addToken = false, isFormData) {

  let token = ''
  if (addToken) {
   token = await getLocalStorageValue('token')
  }

  let options
  options = {
    headers:
      isFormData === true
        ? {
            Accept: 'application/json',
            ...(token && { Authorization: `Bearer ${token}` })
          }
        : {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` })
          },
    method: method,
    ...(params && { body: isFormData ? params : JSON.stringify(params) })
  }

  return new Promise((resolve, reject) => {
    fetch(`${process.env.REACT_APP_API_URL}${path}`, options)
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json
            })
          )
        )
      })
      .then((response) => {
        if (response.ok) {
          return resolve(response.json)
        } else {
          if (response.status === 429) {
            return reject({ _errors: ['Too many login attempts. Try again after 15 minutes.'] })
          } else if (response.status === 401 && !history.location?.pathname.includes('/onboarding') && !history.location?.pathname.includes('/guest') && !history.location.search.includes('invited')) {
            unsetLocalStorageValue('company')
            unsetLocalStorageValue('mainmenu_width')
            unsetLocalStorageValue('token')
            unsetLocalStorageValue('userData')
            unsetLocalStorageValue('traffic_source')
            store.dispatch({ type: 'SET_USER_LOGOUT' })
            store.dispatch(reseTeams_action())
            store.dispatch(resetCompany_action())
            store.dispatch(resetContent_action())
            store.dispatch(resetTemplates_action())
            store.dispatch(resetSubsription_action())
            if (window.amplitude) {
              window.amplitude.getInstance().setUserId(null)
              window.amplitude.getInstance().regenerateDeviceId()
            }
            history.replace('/login')
          } else {
            return reject({ ...response.json, status: response.status })
          }
        }
      })
      .catch((error) => {
        if (error.message) {
          toast.error(error.message)
        } else {
          toast.error(error)
        }
        return reject()
      })
  })
}
